import { render, staticRenderFns } from "./KioskUpdate.vue?vue&type=template&id=6cef3230&"
import script from "./KioskUpdate.vue?vue&type=script&lang=js&"
export * from "./KioskUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports